import { APP_VERSION as e } from "../../../constants.js";
import { processBody as t } from "./process-body.js";
import { processParameters as n } from "./process-parameters.js";
import { processSecuritySchemes as r } from "./process-security-schemes.js";
import { processServerUrl as i } from "./process-server-url.js";
import { filterGlobalCookie as a, getDefaultHeaders as o, restoreConventionalDefaultHeaderNames as s } from "@scalar/workspace-store/request-example";
import { getResolvedRef as c } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { isElectron as l } from "@scalar/helpers/general/is-electron";
//#region src/code-example/helpers/operation-to-har/operation-to-har.ts
var u = ({ includeDefaultHeaders: u = !1, operation: d, contentType: f, method: p, path: m, server: h = null, example: g, securitySchemes: _, globalCookies: v, openapiVersion: y, requestBodyCompositionSelection: b, defaultDisabledParameters: x = !1 }) => {
	let S = u ? o({
		method: p,
		operation: d,
		exampleName: g ?? "default",
		hideDisabledHeaders: !0,
		hideOverriddenHeaders: !0,
		options: {
			isElectron: l(),
			appVersion: e
		}
	}) : {}, C = s(S), w = d["x-scalar-disable-parameters"]?.["global-cookies"]?.[g ?? "default"] ?? {}, T = {
		method: p,
		url: i(h, m),
		headers: Object.entries(C).map(([e, t]) => ({
			name: e,
			value: t
		})),
		queryString: [],
		postData: void 0,
		httpVersion: "HTTP/1.1",
		cookies: [],
		headersSize: -1,
		bodySize: -1
	}, E = !1, D = !1;
	if (d.parameters) {
		let { url: e, headers: t, queryString: r, cookies: i, hasCookieStyleEntries: o, hasSerializedQuery: s } = n({
			harRequest: T,
			parameters: d.parameters,
			openapiVersion: y,
			example: g,
			defaultDisabled: x
		}), c = v?.filter((t) => a({
			cookie: t,
			url: e,
			disabledGlobalCookies: w
		}))?.map((e) => ({
			name: e.name,
			value: e.value
		})) ?? [];
		E = o, D = s ?? !1, T.url = e, T.headers = t, T.queryString = r, T.cookies = [...c, ...i];
	}
	let O = c(d.requestBody);
	if (O?.content) {
		let e = t({
			requestBody: O,
			contentType: f,
			example: g,
			openapiVersion: y,
			requestBodyCompositionSelection: b
		});
		if (e && (T.postData = e, T.bodySize = e.text?.length ?? -1, e.mimeType)) {
			let t = T.headers.find((e) => e.name.toLowerCase() === "content-type");
			t && (!t.value || e.mimeType.startsWith("multipart/") && e.mimeType.includes("boundary=") && e.text !== void 0) ? t.value = e.mimeType : t || T.headers.push({
				name: "Content-Type",
				value: e.mimeType
			});
		}
	}
	let k = D || d.parameters?.some((e) => c(e)?.in === "querystring");
	if (_) {
		let { headers: e, queryString: t, cookies: n } = r(_);
		T.headers.push(...e), T.queryString.push(...t), T.cookies.push(...n);
	}
	let A = T.headers.find((e) => e.name.toLowerCase() === "cookie");
	if (E && A && T.cookies.length) {
		let e = T.cookies.map((e) => `${encodeURIComponent(e.name)}=${encodeURIComponent(e.value)}`).join("; ");
		A.value = A.value ? `${A.value}; ${e}` : e, T.cookies = [];
	}
	if (k && T.queryString.length) {
		let e = T.url.indexOf("#"), t = e === -1 ? "" : T.url.slice(e), n = e === -1 ? T.url : T.url.slice(0, e), r = T.queryString.map(({ name: e, value: t }) => `${encodeURIComponent(e)}=${encodeURIComponent(t)}`).join("&");
		T.url = `${n}${n.includes("?") ? "&" : "?"}${r}${t}`, T.queryString = [];
	}
	T.postData?.mimeType === "multipart/form-data" && T.postData.params?.some((e) => e.fileName !== void 0) && (T.headers = T.headers.filter((e) => e.name.toLowerCase() !== "content-type"));
	let j = 0;
	for (let e of T.headers) j += (e.name?.length ?? 0) + 2 + (e.value?.length ?? 0) + 2;
	return T.headersSize = j, T;
};
//#endregion
export { u as operationToHar };

//# sourceMappingURL=operation-to-har.js.map